import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDown, HelpCircle } from "lucide-react";
import { Link } from "react-router-dom";
import PageHero from "../components/PageHero";
import { CONTACT_EMAIL } from "../constants/contact";

const FAQ_ITEMS = [
  {
    q: "TV13 nedir?",
    a: "TV13, haberden spora, kültürden sanata hayatın her alanında nitelikli içerikler sunan dijital yayın platformudur. Canlı yayınlar, program arşivi ve video içerikleri tek bir yerde toplanır.",
  },
  {
    q: "Canlı yayınları nasıl izleyebilirim?",
    a: "Üst menüden «Canlı Yayın» bölümüne gidebilir veya ana sayfadaki canlı yayın alanından aktif yayına katılabilirsiniz. Yayın, site içinde veya YouTube üzerinden izlenebilir.",
  },
  {
    q: "Program videoları ücretsiz mi?",
    a: "Evet. TV13 üzerindeki program videoları ve arşiv içerikleri izleyicilerimize ücretsiz sunulmaktadır. Bazı canlı yayınlar üçüncü taraf platformlara yönlendirilebilir.",
  },
  {
    q: "Eski bölümleri nerede bulabilirim?",
    a: "«Program Videoları» veya ilgili programın detay sayfasından geçmiş bölümlere erişebilirsiniz. Her programın kendi video listesi bulunur.",
  },
  {
    q: "Reklam ve iş birliği için nasıl iletişime geçebilirim?",
    a: "Reklam, sponsorluk ve iş birliği talepleriniz için İletişim sayfamızdaki formu kullanabilir veya doğrudan e-posta gönderebilirsiniz.",
  },
  {
    q: "İletişim formuma yanıt ne zaman gelir?",
    a: "Mesajlarınız hafta içi 09:00–18:00 saatleri arasında değerlendirilir. Genellikle 1–3 iş günü içinde yanıt verilir.",
  },
  {
    q: "Kişisel verilerim nasıl korunuyor?",
    a: "İletişim formu ve site kullanımı sırasında toplanan veriler 6698 sayılı KVKK kapsamında işlenir. Ayrıntılar için Gizlilik Politikası ve KVKK sayfamıza bakabilirsiniz.",
  },
  {
    q: "Siteyi mobil cihazdan kullanabilir miyim?",
    a: "Evet. TV13 web sitesi mobil telefon ve tabletlerde de uyumlu çalışır; canlı yayın ve videolar mobil tarayıcılardan izlenebilir.",
  },
];

function FaqItem({ item, open, onToggle }) {
  return (
    <div className="tv-card overflow-hidden">
      <button
        type="button"
        onClick={onToggle}
        className="w-full flex items-start justify-between gap-4 p-5 md:p-6 text-left hover:bg-[rgba(139,92,246,0.05)] transition-colors"
      >
        <span className="text-white font-semibold text-sm md:text-base">{item.q}</span>
        <ChevronDown
          size={20}
          className={`shrink-0 text-[var(--tv-purple-bright)] transition-transform ${open ? "rotate-180" : ""}`}
        />
      </button>
      <AnimatePresence initial={false}>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.25 }}
            className="overflow-hidden"
          >
            <p className="px-5 md:px-6 pb-5 md:pb-6 text-[var(--tv-muted)] text-sm md:text-base leading-relaxed border-t border-[var(--tv-border)] pt-4">
              {item.a}
            </p>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default function Faq() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <div>
      <PageHero
        title="Sıkça Sorulan"
        highlight="Sorular"
        subtitle="TV13 hakkında en çok merak edilen konuların yanıtlarını burada bulabilirsiniz."
        image="https://images.unsplash.com/photo-1573167243872-43c6433cce9e"
      />
      <div className="tv-container py-14 max-w-3xl space-y-4">
        {FAQ_ITEMS.map((item, i) => (
          <FaqItem
            key={i}
            item={item}
            open={openIndex === i}
            onToggle={() => setOpenIndex(openIndex === i ? -1 : i)}
          />
        ))}

        <div className="tv-card p-6 md:p-8 flex flex-col sm:flex-row items-start sm:items-center gap-4 mt-8">
          <div className="w-12 h-12 rounded-xl bg-[rgba(139,92,246,0.15)] border border-[rgba(168,85,247,0.3)] flex items-center justify-center shrink-0">
            <HelpCircle size={24} className="text-[var(--tv-purple-bright)]" />
          </div>
          <div className="flex-1">
            <h2 className="text-white font-semibold">Sorunuz yanıtlanmadı mı?</h2>
            <p className="text-[var(--tv-muted)] text-sm mt-1">
              Bize{" "}
              <a href={`mailto:${CONTACT_EMAIL}`} className="text-[var(--tv-purple-bright)] hover:underline">
                {CONTACT_EMAIL}
              </a>
              adresinden yazabilir veya{" "}
              <Link to="/iletisim" className="text-[var(--tv-purple-bright)] hover:underline">
                iletişim formunu
              </Link>
              kullanabilirsiniz.
            </p>
          </div>
          <Link to="/iletisim" className="tv-btn-primary shrink-0">İletişime Geç</Link>
        </div>
      </div>
    </div>
  );
}
